import gql from 'graphql-tag';

const CREATE_PRICESHEET = gql`
  mutation CreatePricesheet($label: String!, $baseMarkup: Float!, $scope: String!, $scopeId: String!) {
    createPricesheet(label: $label, baseMarkup: $baseMarkup, scope: $scope, scopeId: $scopeId) {
      id,
      label,
      baseMarkup,
      scope,
      scopeId
    }
  }
`;

export default CREATE_PRICESHEET;
